const root = 'FiltersDrawerCheckboxList'
const listItem = `${root}-listItem`

export const TestId = {
  listItem,
  listItemCheckbox: `${listItem}-checkbox`,
  listItemText: `${listItem}-text`,
}
